import { render, staticRenderFns } from "./Dialer.vue?vue&type=template&id=0cbdb126&scoped=true"
import script from "./Dialer.vue?vue&type=script&lang=js"
export * from "./Dialer.vue?vue&type=script&lang=js"
import style0 from "./Dialer.vue?vue&type=style&index=0&id=0cbdb126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbdb126",
  null
  
)

export default component.exports